
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.12 8.901c.186-.124.415-.234.68-.32v2.038a2.768 2.768 0 01-.68-.32c-.437-.292-.52-.562-.52-.7 0-.136.083-.406.52-.698zM13.2 15.419V13.38c.265.086.494.197.68.32.437.292.52.562.52.699 0 .137-.083.407-.52.698a2.769 2.769 0 01-.68.32z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21.6a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2zM13.2 6a1.2 1.2 0 00-2.4 0v.11c-.746.14-1.436.41-2.011.794-.866.578-1.59 1.507-1.59 2.696 0 1.189.724 2.118 1.59 2.695a5.442 5.442 0 002.01.794v2.33c-.468-.152-.816-.38-1.011-.606a1.2 1.2 0 00-1.813 1.573c.675.778 1.696 1.29 2.825 1.503V18a1.2 1.2 0 102.4 0v-.11a5.443 5.443 0 002.011-.794c.866-.577 1.589-1.506 1.589-2.695 0-1.189-.723-2.118-1.589-2.696a5.442 5.442 0 00-2.011-.794V8.58c.47.153.817.382 1.012.606a1.2 1.2 0 101.813-1.573c-.675-.777-1.697-1.29-2.825-1.502V6z","fill":"#fff"}})])
          )
        }
      }
    